"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHandleClickOutside = void 0;
var _react = require("react");
var useHandleClickOutside = function useHandleClickOutside(isOpen, onClose, refs) {
  var handleClickOutside = (0, _react.useCallback)(function (e) {
    /* istanbul ignore else */
    if (isOpen) {
      refs.every(function (ref) {
        var _ref$current;
        if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(e.target))) {
          onClose();
        }
      });
    }
  }, [isOpen, refs, onClose]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
};
exports.useHandleClickOutside = useHandleClickOutside;